@if (!filteredRisks.length) {
  <div class="gravimetric-results-div curved-section-shadow">
    @if (loadingSensorLabResults) {
      <app-widget-loader class="smaller-loader">
      </app-widget-loader>
    } @else {
      <div class="no-result-div d-flex w-100 justify-content-center align-items-center">
        <h3 class="no-result-title mr-2 mt-2 mb-0 text-bold">
        {{(isSampleTypeNoise ? 'No Results' :'No Lab Result Available') | translate}} </h3>
      </div>
    }
  </div>
} @else {
  <div class="jurisdictions-columns" [ngClass]="{
    'single-jurisdiction': groupedRisks.length === 1,
    'multi-jurisdiction': groupedRisks.length > 1
  }">
    @for (group of groupedRisks; track trackByIndex($index)) {
      <div class="jurisdiction-column">
        <h3 class="jurisdiction-heading">{{'Jurisdiction' | translate}}: <b>{{ group.jurisdictionName || ('No Jurisdiction' | translate) }}</b></h3>
        <div class="analyte-cards-grid">
          @for (risk of group.results; track trackByIndex($index)) {
            <div class="analyte-card-wrapper">
              <div class="gravimetric-results-div curved-section-shadow analyte-meter-wrap">
                @if (risk?.Value != null || risk.isLoq) {
                  <div class="analyte-left-bar" [style]="'background-color:'+ risk.exposureColor"></div>
                }
                <div class="analyte-info d-flex justify-content-between w-100">
                  <div class="d-flex flex-column">
                    <span class="text-custom-yellow fs-10 text-uppercase">{{'Analyte' | translate}}</span>
                    <span class="text-bold fs-14">{{risk?.analyteName}}</span>
                  </div>
                  <div class="d-flex flex-column align-items-end">
                    @if (!risk.isLoq) {
                      @if (!isSampleTypeNoise) {
                        <span class="text-custom-yellow fs-10 text-uppercase">{{ (isSampleTypeBiological ? '% of BEI' : 'Severity') | translate }}</span>
                        <span class="text-bold fs-12" [style]="'color:'+ risk.exposureColor">
                          {{ risk?.Value != null ? risk.Value + '%' : '' }}
                        </span>
                      } @else {
                        @if (showNoiseDoseComparison) {
                          <span class="text-custom-yellow fs-10 text-uppercase">{{'Dose %' | translate}}</span>
                          <span class="text-bold fs-12">{{ risk?.rawDosePercentage != null ? risk.rawDosePercentage + '%' : '-' }}</span>
                        }
                        <span class="text-custom-yellow fs-10 text-uppercase">{{'Shift Adjusted Dose %' | translate}}</span>
                        <span class="text-bold fs-12" [style]="'color:'+ risk.exposureColor">
                          {{ risk?.shiftAdjustedDosePercentage != null ? ((risk.shiftAdjustedDosePercentage | number:'1.1-1') + '%') : '-' }}
                        </span>
                      }
                    } @else {
                    }
                  </div>
                </div>
                <div class="analyte-meter w-100 pt-1">
                  @if (risk.isLoq) {
                    <div class="line-top-text d-flex">
                      <h6 class="text-bold fs-16" [style]="'color:'+ risk.exposureColor">{{ risk.loqDisplayText }}</h6>
                    </div>
                  }
                  @if (!risk.isLoq && risk?.Value != null) {
                    <div class="analyte-meter-line">
                      <div class="line-top-text d-flex justify-content-between">
                        <h6 class="text-bold fs-16">{{risk?.sampleSign}} {{$safeNavigationMigration(risk?.twa) | number: '0.0-4' }}</h6>
                        <span class="fs-12">{{risk?.Unit}}</span>
                      </div>
                      <div class="grey-line">
                        <div class="threshold-line" [style]="risk.exposureStyle + 'background-color:'+ risk.exposureColor">
                        </div>
                        @if (risk?.oelLine) {
                          <span class="oel-line" [ngStyle]="{'left': risk.oelLine + '%'}"></span>
                        }
                      </div>
                      <div class="dashed-grey-line">
                        @for (gravimetric of risk['gravimetric']; track trackByIndex($index)) {
                          <span class="colored-line"
                          [style]="gravimetric.style"></span>
                        }
                      </div>
                      <div class="line-bottom-text">
                        <span class="fs-12">{{ (isSampleTypeBiological ? 'BEI' : 'OEL') | translate }}{{ isSampleTypeBiological ? '' : risk?.oelLabel }} = {{$safeNavigationMigration(risk?.oelValue) | number: (isSampleTypeNoise ? '0.0-2' : '0.0-4')}} {{risk?.Unit}}</span>
                      </div>
                    </div>
                  }
                  @if (!risk.isLoq && risk?.Value == null) {
                    <div >
                      @if (risk?.mass != null) {
                        <div class="line-top-text d-flex">
                          <h6 class="text-bold fs-16">{{$safeNavigationMigration(risk?.mass) | number: '0.0-4' }}</h6>
                          <span class="fs-12 pl-1">{{risk?.massUnit}}</span>
                        </div>
                      } @else {
                        <b class="mr-2 fs-12">{{(isSampleTypeNoise ? 'No Results' :'No Gravimetric Results') | translate}}.</b>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
}

